module.exports = __webpack_public_path__ + "static/media/fly0073.04420f67.webp";